import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export function paymentsReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return queryOptions({
    queryKey: reportKeys.payments(storeId, { from, to }),
    queryFn: () => reportsApi.payments(storeId, { from, to }),
    placeholderData: keepPreviousData,
  });
}

export function usePaymentsReport(storeId: string, range: DayRange) {
  return useQuery(paymentsReportQueryOptions(storeId, range));
}
